module.exports = __webpack_public_path__ + "static/media/project-ml-assist.6f2dc06b.png";